import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for the Home Page (/)
 */
export const homePageTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Home_Ops_Title"),
    description: t("Tour_Home_Ops_Description"),
    target: () => queryTourTarget("home-ops-grid"),
    placement: "bottom",
  },
  {
    title: t("Tour_Home_Occupancy_Title"),
    description: t("Tour_Home_Occupancy_Description"),
    target: () => queryTourTarget("home-occupancy-card"),
    placement: "bottom",
  },
  {
    title: t("Tour_Home_RentDue_Title"),
    description: t("Tour_Home_RentDue_Description"),
    target: () => queryTourTarget("home-rent-due-card"),
    placement: "bottom",
  },
  {
    title: t("Tour_Home_LeasesReview_Title"),
    description: t("Tour_Home_LeasesReview_Description"),
    target: () => queryTourTarget("home-leases-review-card"),
    placement: "bottom",
  },
];
